import { useState } from 'react';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import DraggableModal from '../../../components/commonAction/DraggableModal';
import { Modal } from 'react-bootstrap';

const SendDoNotSendModal = (props) => {
    const {
        sendDoNotSendModalOpened,
        handleCloseSendDoNotSendModal,
        makeSendDoNotSendRequest,
    } = props;

    const [date, setDate] = useState(null);

    const handleSave = () => {
        makeSendDoNotSendRequest(date);
    };

    return (
        <DraggableModal
            show={sendDoNotSendModalOpened}
            onHide={handleCloseSendDoNotSendModal}
            animation={false}
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Header
                closeButton
                className='modal-header d-block justify-content-start'
            >
                <Modal.Title className='d-flex align-items-stretch justify-content-between'>
                    <div>Send / Do Not Send</div>
                    <i
                        title='Close'
                        className='fa-light fa-xmark d-flex justify-content-end align-items-center'
                        aria-hidden='true'
                        onClick={handleCloseSendDoNotSendModal}
                    />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='deletes'>
                <form>
                    <div className='form-group'>
                        <div>
                            <label>Do Not Send Until (OPTIONAL)</label>
                            <div>
                                <DatePicker
                                    onChange={setDate}
                                    value={date}
                                    format='MM/dd/y'
                                    className='form-control position-relative date-picker color-black'
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='d-block'>
                <div className='d-flex footer-btn align-items-stretch justify-content-between'>
                    <div className='d-flex'>
                        <Button
                            variant='secondary'
                            onClick={handleCloseSendDoNotSendModal}
                            title='Cancel'
                        >
                            Cancel
                        </Button>
                    </div>
                    <div className='d-flex'>
                        <Button
                            variant='success'
                            onClick={handleSave}
                            title='Save'
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </DraggableModal>
    );
};

export default SendDoNotSendModal;
